import React, { useEffect, useState } from 'react';
import httpCommon from '../../../http-common';
import { MenuItem, Select } from '@mui/material';
import { edit_schedule_api } from '../../Output/utils/edit_schedule_service';

const RealTimeMachineDropDown = ({
    id,
    field,
    row,
    rowNode,
    colDef,
    cellMode,
    hasFocus,
    tabIndex,
    value,
    formattedValue,
    isEditable,
    api
}) => {
    const [machines, setMachines] = useState([]);
    const get_required_machines = async () => {
        const { test_name } = row;
        const response = await httpCommon.get(`/v1/qc/get_machine_for_test?test_id=${encodeURIComponent(test_name)}`);
        const result = response.data;
        // console.log(result);
        setMachines(result.required_machines);
        return result;
    };
    const [selected_machine, set_selected_machine] = useState(row.machine_id);
    useEffect(() => {
        get_required_machines();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            {
                !isEditable ? selected_machine :
                    (machines && machines.length > 0 ?
                        <Select
                            id={`${id}`}
                            value={selected_machine}
                            label="Machine ID"
                            size="small"
                            onChange={
                                async (e) => {
                                    set_selected_machine(e.target.value);
                                    const { _id } = row;
                                    const response = await edit_schedule_api({ _id, machine_id: e.target.value });
                                    console.log(response);
                                    if (response.status) {
                                        api.updateRows([{ id, machine_id: e.target.value }]);
                                    }
                                    else {
                                        alert(response.message);
                                    }
                                    row.analyst_id = e.target.value;
                                }
                            }
                        >
                            {
                                machines.map((machine) => (
                                    <MenuItem key={`${id}-${machine}`} value={machine}>
                                        {machine}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                        :
                        selected_machine)
            }
        </div>
    );
};

export default RealTimeMachineDropDown;